/* unplugin-vue-components disabled */import script from "./MemberLink.vue?vue&type=script&lang=ts&setup=true"
export * from "./MemberLink.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__